import React from 'react';
import { BlockProntoPago, PeriodTitle } from './styled';
import iconProntoPago from '../../../../assets/icons/payments/iconPorcentageProntoPago.svg';
import { PayItem } from './PayItem';
import DateHelpers from '@/core/helpers/DateHelper';
import { Card, CheckButton } from '../modules/PayOnline/PayOnline.styled';
import { formatAmount } from '../modules/PayOnline/helpers';

interface PayItemsByPeriodProps {
  hasProntoPago?: boolean;
  paymentsArray: any[];
  period: string;
  isPasarela?: boolean;
  currentPay: number;
  paysSelected?: string[];
  isDiscountFullCycleActive?: boolean;
  handleCheckboxChange?: (_: string, b: number) => void;
  hasExpiredPayment?: boolean;
}

const PayItemsByPeriod = ({
  hasProntoPago,
  paymentsArray,
  period,
  isPasarela = false,
  currentPay,
  paysSelected = [],
  isDiscountFullCycleActive = false,
  handleCheckboxChange = () => {},
  hasExpiredPayment = true
}: PayItemsByPeriodProps) => (
  <div style={{ marginBottom: isPasarela ? 0 : '24px' }}>
    {period && <PeriodTitle>{DateHelpers.periodToName(period)}</PeriodTitle>}

    {hasProntoPago && !isDiscountFullCycleActive && !hasExpiredPayment && (
      <BlockProntoPago>
        <img src={iconProntoPago} alt="Pronto Pago Icon" />
        <span>
          Ahorra <strong>hasta 5% de descuento</strong> en tus cuotas pagando
          hasta 1 día hábil antes del vencimiento.
        </span>
      </BlockProntoPago>
    )}

    {isPasarela
      ? paymentsArray
          ?.filter((item) => item.periodDesc === period)
          .map((item) => {
            const valDisabled = paymentsArray.findIndex(
              (el) => el.itemNumber === item.itemNumber
            );
            const updateItem = {
              ...item,
              amountToPayStr: formatAmount(item.amountToPay ?? '')
            };
            return (
              <Card
                key={item.itemNumber}
                className="list"
                data-testid="payments-card-result"
                style={{
                  display: 'flex',
                  width: '100%',
                  marginBottom: 8
                }}
              >
                <CheckButton>
                  <input
                    data-testid={`checkbox-input`}
                    style={{
                      visibility: 'inherit',
                      accentColor: '#745EF6',
                      width: 16,
                      height: 16
                    }}
                    type="checkbox"
                    disabled={valDisabled > currentPay}
                    checked={paysSelected.includes(item.itemNumber)}
                    onChange={() =>
                      handleCheckboxChange(item.itemNumber, currentPay)
                    }
                  />
                </CheckButton>
                <PayItem key={item.itemNumber} {...updateItem} isPasarela />
              </Card>
            );
          })
      : paymentsArray
          ?.filter((item) => item.periodDesc === period)
          .map((item) => {
            const updateItem = {
              ...item,
              amountToPayStr: formatAmount(item.amountToPay ?? '')
            };
            return <PayItem key={item.itemNumber} {...updateItem} />;
          })}
  </div>
);

export { PayItemsByPeriod };
